module.exports = __webpack_public_path__ + "img/mission-gfp-animals.jpg?27011c1e019068c6d9054467d4297a65";